<template>
    <Transition name="fade">
        <div v-if="isOpen" class="overlay-backdrop" @click.self="close">
            <div class="overlay-container" :class="overlayClass">
                <header class="overlay-header">
                    <h3>{{ title }}</h3>
                    <button class="overlay-close" @click="close" aria-label="Schließen">
                        <BaseIcon name="ri-close-line" />
                    </button>
                </header>
                <div class="overlay-content">
                    <div v-if="message" v-html="message"></div>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import BaseIcon from "../component/BaseIcon.vue";
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { OverlayService } from '../service/OverlayService';

const isOpen = ref(false);
const currentId = ref(null);
const title = ref('');
const message = ref('');
const type = ref('info');

const overlayClass = computed(() => {
    return {
        'overlay--success': type.value === 'success',
        'overlay--error': type.value === 'error',
        'overlay--info': type.value === 'info'
    };
});

const open = (options) => {
    currentId.value = options.id || null;
    title.value = options.title || (options.type === 'error' ? 'Fehler' : 'Information');
    message.value = options.message || '';
    type.value = options.type || 'info';
    isOpen.value = true;
    document.body.classList.add('overlay-open');
};

const close = () => {
    isOpen.value = false;
    document.body.classList.remove('overlay-open');
    OverlayService.emit('closed', { id: currentId.value });
};

const handleKeydown = (e) => {
    if (e.key === 'Escape' && isOpen.value) {
        close();
    }
};

onMounted(() => {
    OverlayService.on('open', open);
    OverlayService.on('close', close);
    window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
    OverlayService.off('open', open);
    OverlayService.off('close', close);
    window.removeEventListener('keydown', handleKeydown);
});
</script>
